import Check from '@/components/Check';
import CertificationNumber from './CertificationNumber';
import getQuestionFormatLabel from './getQuestionFormatLabel';

export default function CertificationExamFormat({ formats }) {
  if (formats === null || formats.length === 0) {
    return null;
  }

  let finalFormats = typeof formats === 'string' ? formats.split(',') : formats;

  return (
    <ul className="space-y-2 text-base">
      {finalFormats.map((f) => (
        <li key={`question-format-${f}`}>
          <CertificationNumber
            label={getQuestionFormatLabel(f)}
            value={<Check className="text-green-400" />}
          />
        </li>
      ))}
    </ul>
  );
}
